import React from 'react';
import { Link } from 'react-router-dom';
import '../css/CommonStyles.css';
import Header from '../components/Header';

function RankingPage() {

  return (
    <div>
        <Header />
    </div>
  );
}

export default RankingPage;